import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'src/app/shared/services/cookie.service';

export const authGuard: CanActivateFn = (route, state) => {
  const cookieService = inject(CookieService);
  const router = inject(Router);

  if (!cookieService.get(cookieService.COOKIE_NAME)) {
    router.navigate(['/']);
    return false;
  }
  return true;
};
